import {StoppageAnalysisPage} from '@features/stoppage-analysis'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router'

import {useTranslationPrefix} from '../hooks/useTranslationPrefix'

type PathParameter = {
  plantId: string
}

export const StoppageAnalysis = () => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('Missing plantId or equipmentId prop')

  const {t} = useTranslation()
  const {performancePrefix} = useTranslationPrefix()

  return (
    <StoppageAnalysisPage
      plantId={plantId}
      pageTitle={t(`${performancePrefix}.stoppageAnalysis.label.title`)}
    />
  )
}
